import React, {useEffect} from "react";
import {ImagesBanAds} from "../../../constant/DumpAds"

const RightTopAds = () => {



    useEffect(() => {
        const data = ImagesBanAds;
        let l = data.length;
        let randomAds = Math.floor(l*Math.random())
        document.getElementById("rightTopAds").src = data[randomAds]

    }, []);

    return (
        <div style={{ height: "auto" }}>
            <img id="rightTopAds" src="" alt="right-ads" />
            <div className="clear" />
        </div>
    );
};

export default RightTopAds;
